function openInvoiceHistory (memberId) {
  window.open(`/members/${memberId}/member_invoices`);
  return true;
}
export default openInvoiceHistory;
